/**
 * @generated SignedSource<<b8e64e2ae272a19c7631e631949206f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchTitleFragment$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "BrainSearchTitleFragment";
};
export type BrainSearchTitleFragment$key = {
  readonly " $data"?: BrainSearchTitleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchTitleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./BrainSearchTitleRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "BrainSearchTitleFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "BrainSearch",
  "abstractKey": null
};

(node as any).hash = "b5953ae6fad884f9b9f00e9c22977b88";

export default node;
